// Icon & IconButton definitions
export type IconButtonAppearance = 'default' | 'invisible' | 'primary';
export type IconButtonSize = 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
export type DropdownIconButtonAppearance = 'default' | 'invisible' | 'emphasize';
export type InternalIconButtonAppearance = IconButtonAppearance | DropdownIconButtonAppearance;

export const IconSizes: Record<IconButtonSize, number> = {
  xsmall: 10,
  small: 14,
  medium: 14,
  large: 24,
  xlarge: 48,
};

// Dropdown definitions
export type DropdownOpenAxis = 'vertical' | 'horizontal';
export enum DropdownOpenAxisOptions {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}
